module.exports = __webpack_public_path__ + "fonts/Catamaran-Bold.4a133d83.woff2";